import React from 'react';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import bar3Animation from '../assets/bar3Animation.svg';
import bar4Animation from '../assets/bar4Animation.svg';

const useStyles = makeStyles((theme) => ({
  infoGraphCont: {
    marginTop: '3.125rem',
    width: '51%',
    maxWidth: '600px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '75%',
      textAlign: 'left'
    }
  },
  infoGraphTit: {
    ...theme.extraFonts.insertTitle
  },
  barNLabel: {
    marginTop: '1.25rem'
  },
  graphicImg: {
    marginLeft: '1rem',
    height: '40px',
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0
    }
  },
  graphic1: {
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '278px'
    }
  }
}));

const WhyDoesStat2 = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const { ref, inView } = useInView({ triggerOnce: 'true' });

  const renderer = (
    <Grid
      container
      justifyContent={matchesSM ? 'flex-start' : 'center'}
      className={classes.graphic1}
    >
      <Typography className={classes.infoGraphTit}>
        Cervical Cancer Rates
        <br /> (Per 100,000 women)
      </Typography>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
        style={{ width: '80%' }}
      >
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          direction={matchesSM ? 'column' : 'row'}
          className={classes.barNLabel}
        >
          <Typography variant="body2" style={{ width: '110px' }}>
            Hispanic Women
          </Typography>
          <object
            type="image/svg+xml"
            data={bar3Animation}
            aria-label="graphic bar"
            className={classes.graphicImg}
          ></object>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          direction={matchesSM ? 'column' : 'row'}
          className={classes.barNLabel}
        >
          <Typography variant="body2" style={{ width: '110px' }}>
            White Women
          </Typography>
          <object
            type="image/svg+xml"
            data={bar4Animation}
            aria-label="graphic bar"
            className={classes.graphicImg}
          ></object>
        </Grid>
      </Grid>
      <Typography variant="body2" className={classes.infoGraphText}>
        Black women have been shown to develop breast cancer earlier than white women, with a median
        age of first diagnoses occurring at 59 years old compared to 63 for white women. women.
        <sup>10</sup>
      </Typography>
    </Grid>
  );

  return (
    <>
      <Grid
        component={motion.div}
        ref={ref}
        container
        justifyContent="center"
        alignItems="center"
        className={classes.infoGraphCont}
      >
        {inView ? renderer : null}
      </Grid>
    </>
  );
};

export default WhyDoesStat2;
